export class SendEmailService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;
    this.sendEmailUrl = this.apiService.getResourceUrl(
      "/account/send-email-to-veterans"
    );

    this.sendEmailResource = this.$resource(this.sendEmailUrl, null, {
      update: {
        method: "put",
      },
    });
  }
  sendEmailToVeterans(data) {
    const promise = this.sendEmailResource.update(data).$promise;
    return promise.then((response) => response);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/send-email/send-email.service.js